import { IApiRequest } from "@miplatform/types";
import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_BUILD_TEMPLATE = `${TASK_SERVICE}/build-templates`;

export const buildTemplate = {
  getAll: async ({ filters, sort, params, signal }: IApiRequest = {}) => {
    const options = await apiOptions({
      url: API_BUILD_TEMPLATE,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
    });
    return apiRequest(options);
  },
  get: async ({ id, sort, signal }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_BUILD_TEMPLATE}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      sort,
      signal,
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: API_BUILD_TEMPLATE,
      headers: { [X_API_VERSION]: API_VERSION },
      method: "post",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, modifiedOn, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_BUILD_TEMPLATE}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data: {
        modifiedOn,
      },
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }: IApiRequest) => {
    const options = await apiOptions({
      url: `${API_BUILD_TEMPLATE}/${id}`,
      headers: { [X_API_VERSION]: API_VERSION },
      method: "patch",
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
};
